import React from 'react';
import styled from 'styled-components';
import FilterByDeparture from './components/filterByDeparture/FilterByDeparture';
import FilterByMonth from './components/filterByMonth/FilterByMonth';
import FilterByTravelLength from './components/filterByTravelLength/FilterByTravelLength';
import { mediaQueries } from 'styles/utils/mediaQueries';

function FiltersComponent() {
  return (
    <Root>
      <FilterByDeparture />
      <FilterByMonth />
      <FilterByTravelLength />
    </Root>
  );
}

export default FiltersComponent;

const Root = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 0 32px;

  @media (max-width: 768px) {
    justify-content: space-between;

    & > * {
      flex-grow: 1;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  > *:not(:last-child) {
    margin-right: 16px;
  }
`;
